// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cSw7","comment":"styles_comment__ussAK"};